import React, { useContext, useEffect, useState } from "react";
import ModalCustom from "../components/common/ModalCustom";
import { Col, Row } from "reactstrap";
import ButtonIcon from "../components/common/ButtonIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserLock } from "@fortawesome/free-solid-svg-icons";
import AppContext from "../context/Context";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { faPaypal } from "@fortawesome/free-brands-svg-icons";
import apiCall from "../services/apiCall";

const CardExpireModal = () => {
  let { loginUserDetails } = useContext(AppContext);
  const [is2faModelOpen, setIs2faModelOpen] = useState(false);
  const history = useHistory();
  const [cardDetails, setCardDetails] = useState([]);
  const [reloadStatus, setReloadStatus] = useState(false);
  const [days, setDays] = useState("");

  useEffect(() => {
    // get recovery questions
    let params = {
      devid:
        loginUserDetails.is_partner == "1"
          ? loginUserDetails?.parent_dev_id
          : loginUserDetails?.dev_id,
    };
    apiCall
      .servertrip("GET", "credit_card_details", loginUserDetails, params)
      .then((res) => {
        if (res.data.items.length > 0) {
          setIs2faModelOpen(true);
          sessionStorage.setItem("cardExpireShown", "true");
          setCardDetails(res.data.items);
          setDays(res.data.items[0].days);
        } else {
          setIs2faModelOpen(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // useEffect(() => {
  //   let params = {
  //     devid:
  //       loginUserDetails.is_partner == "1"
  //         ? loginUserDetails.parent_dev_id
  //         : loginUserDetails.dev_id,
  //     host: "qa",
  //   };
  //   // debugger;
  //   apiCall.servertrip("GET", "payment_details", loginUserDetails, params).then(
  //     (res) => {
  //       if (res.status !== 204 && res.data.message !== "null") {
  //         console.log(res.data.authorizedDotNetCardData);
  //       }
  //     },
  //     (error) => {
  //       console.log(error);
  //     }
  //   );
  // }, []);

  const buttonSubmit = () => {
    if (loginUserDetails.is_partner == "0") {
      history.push(`${process.env.PUBLIC_URL}/admin/billing`);
    } else {
      history.push({
        pathname: `${process.env.PUBLIC_URL}/user/billing`,
        state: { defaultKey: "payment" }
      });
    }
    setIs2faModelOpen(false);
    // toast.success("Payment method updated successfully");
  };

  return (
    <>
      <ModalCustom
        title={"Credit Card Expiring"}
        openPopup={is2faModelOpen}
        setOpenPopup={setIs2faModelOpen}
        size="md"
        centered
        fade={false}
        backdrop={"static"}
        // isHeaderCloseBtn={false}
        keyboard={false}
      >
        <Row>
          <Col>
            <h4 className="text-dark">Your card is about to expire</h4>
            <br />
            <h6 className="text-body">
              Please update your credit card on file to avoid any service interruptions.
            </h6>
            <br />

            <h6 className="text-secondary">Payment method</h6>
            <h6 className="text-dark">
              {cardDetails.map((card) => {
                return <div>card ending with {card.card_number}</div>;
              })}
            </h6>
          </Col>
        </Row>
        <br />
        {loginUserDetails.is_partner == "1" &&
        loginUserDetails.user_type == "User" ? (
          ""
        ) : (
          <>
            <Row>
              <Col>
                <ButtonIcon
                  color="outline-primary"
                  size="sm"
                  icon="Sync"
                  className="ml-1 mt-lg-2 mt-sm-2 mt-md-2 mb-2"
                  iconClassName="fs--2"
                  onClick={() => {
                    buttonSubmit();
                  }}
                >
                  {/* <FontAwesomeIcon
                style={{ marginRight: "5px" }}
                icon={faPaypal}
              /> */}
                  Update Payment Method
                </ButtonIcon>
              </Col>
            </Row>
          </>
        )}

        <br />
      </ModalCustom>
    </>
  );
};

export default CardExpireModal;
